import * as React from "react";
import classnames from "classnames";
import { Heading, Text } from "@grandvisionhq/elements";
import Link from "../../Link/Link/Link.js";
/* empty css                   */
const AdditionalInfo = ({ title, description, firstLink, secondLink }) => {
  return /* @__PURE__ */ React.createElement("div", { className: classnames("additional-info", { "additional-info__flex": !description }) }, /* @__PURE__ */ React.createElement(Heading, { variant: "small", className: "support-footer__title" }, title), /* @__PURE__ */ React.createElement("div", { className: "support-footer__contact-details" }, description && /* @__PURE__ */ React.createElement(Text, { className: "support-footer__description" }, description), /* @__PURE__ */ React.createElement("div", { className: "info", "data-t": "additionalInfo" }, firstLink.label && /* @__PURE__ */ React.createElement(Link, { iconBefore: firstLink.icon, url: firstLink.url, className: "support-footer__link" }, firstLink.label), secondLink.label && /* @__PURE__ */ React.createElement(
    Link,
    {
      iconBefore: secondLink.icon,
      url: secondLink.url,
      className: "support-footer__link"
    },
    secondLink.label
  ))));
};
export {
  AdditionalInfo
};
//# sourceMappingURL=AdditionalInfo.js.map
